import { Company } from "@/types";
import { create } from "zustand";

interface CurrentCompanyStore {
  company: Company | null;
  setCompany: (company: Company) => void;
}

export const useCurrentCompanyStore = create<CurrentCompanyStore>((set) => ({
  company: null,
  setCompany: (company: Company) => set({ company }),
}));
